import { DATE_FORMAT_SHORT, formatDate } from '@findy-code/utils/date';
import { Heading } from '@findy-code/yuffie/ui/heading';
import { Stack } from '@findy-code/yuffie/ui/stack';
import { Tag } from '@findy-code/yuffie/ui/tag';
import { Text } from '@findy-code/yuffie/ui/text';

import styles from './company-detail-entries.component.module.scss';
import { SectionLayout } from './section-layout.component';

type EntryType = {
  title: string;
  url: string;
  publishedAt?: string | null;
  skills: Array<{
    id: number;
    name: string;
  }>;
};

export const EntryItem = ({ title, url, publishedAt, skills }: EntryType) => {
  return (
    <article className={styles.entryItemCard}>
      <a href={url} rel="noopener" target="_blank">
        <Heading as="h3" className={styles.cardTitle} font="heading-m">
          {title}
        </Heading>
      </a>
      <ul className={styles.skillList}>
        {skills.slice(0, 4).map((skill) => (
          <li key={skill.id}>
            <Tag>{skill.name}</Tag>
          </li>
        ))}
      </ul>
      <div className={styles.footer}>
        <Stack spacing="xxs">
          <Text font="caption-m">
            <time>{formatDate(publishedAt, DATE_FORMAT_SHORT)}</time>
          </Text>
        </Stack>
      </div>
    </article>
  );
};

type Props = {
  entries: EntryType[];
  blogUrl: string;
};

export const CompanyDetailEntries = (props: Props) => {
  return (
    <SectionLayout
      heading={{
        title: '技術ブログ',
      }}
      id="entries"
    >
      <Stack spacing="m">
        {props.entries.map((entry) => {
          return <EntryItem {...entry} key={entry.url} />;
        })}
      </Stack>
    </SectionLayout>
  );
};
